module.exports = __webpack_public_path__ + "img/ColoredSpace7.f94d12da.jpg";